<template>
  <div>
    <CRow>
      <CCol class="text-center">
        <img alt="MFU" src="@/assets/img/logo.png" style="width: 12%"><br>
        <h3 class="text-uppercase m-0 mb-2">Mae Fah Luang University</h3>
        <h6 class="text-uppercase" v-if="results">Examset Analytic Report</h6><br><br>
      </CCol>
    </CRow>
    <CRow v-if="results">
      <CCol>
        <CRow>
          <CCol col="4">
            <strong>Course code: </strong>
          </CCol>
          <CCol col="8">
            {{ results.courseCode }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong>Section: </strong>
          </CCol>
          <CCol col="8">
            {{ results.section ? results.section : "-" }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong>Question: </strong>
          </CCol>
          <CCol col="8">
            {{ results.numberOfQuestions }} items
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong>Number of Student: </strong>
          </CCol>
          <CCol col="8">
            {{ results.numberOfStudents }} students
          </CCol>
        </CRow>
        <br>
        <CRow v-if="results.name">
          <CCol col="4">
            <strong>Exam: </strong>
          </CCol>
          <CCol col="8">
            {{ results.name }}
          </CCol>
        </CRow>
        <CRow v-if="results.code">
          <CCol col="4">
            <strong>Exam code: </strong>
          </CCol>
          <CCol col="8">
            {{ results.code }}
          </CCol>
        </CRow>
        <CRow v-if="results.numberOfUse">
          <CCol class="pr-0" col="4">
            <strong>Number of Use: </strong>
          </CCol>
          <CCol col="8">
            {{ results.numberOfUse }}
          </CCol>
        </CRow>
        <CRow>
          <CCol class="pr-0" col="4">
            <strong>Standard Deviation </strong>
          </CCol>
          <CCol col="8">
            {{ results.standardDeviation.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong> Variance (SD<sup>2</sup>): </strong>
          </CCol>
          <CCol col="8">
            {{ results.variance.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong> Standard Error: </strong>
          </CCol>
          <CCol col="8">
            {{ results.standardError.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong>R-value: </strong>
          </CCol>
          <CCol col="8">
            {{ results.krTwenty.toFixed(2) }}
          </CCol>
        </CRow>
        <br>
        <CRow>
          <CCol class="pr-0" col="4">
            <strong>Analyzed date:</strong>
          </CCol>
          <CCol col="8">
            {{ results.date ? getDate(results.date) : getDate(results.createdAt) }}
          </CCol>
        </CRow>
      </CCol>
      <CCol>
        <CRow>
          <CCol class="pr-0" col="4">
            <strong>Average score: </strong>
          </CCol>
          <CCol class="pl-0" col="8">
            {{ results.averageScore.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong>Max score: </strong>
          </CCol>
          <CCol class="pl-0" col="8">
            {{ results.maxScore }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="4">
            <strong>Min score: </strong>
          </CCol>
          <CCol class="pl-0" col="8">
            {{ results.minScore }}
          </CCol>
        </CRow>
        <br>
        <CRow>
          <CCol class="pr-0" col="5">
            <strong>Average Difficulty Index: </strong>
          </CCol>
          <CCol class="pl-0" col="7">
            {{ results.difficultyIndex.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="5">
            <strong>Max Difficulty Index: </strong>
          </CCol>
          <CCol class="pl-0" col="7">
            {{ results.maxDifficultyIndex.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="5">
            <strong>Min Difficulty Index: </strong>
          </CCol>
          <CCol class="pl-0" col="7">
            {{ results.minDifficultyIndex.toFixed(2) }}
          </CCol>
        </CRow>
        <br>
        <CRow>
          <CCol class="pr-0" col="6">
            <strong>Average Discrimination Index: </strong>
          </CCol>
          <CCol class="pl-0" col="6">
            {{ results.discriminationIndex.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="6">
            <strong>Max Discrimination Index: </strong>
          </CCol>
          <CCol class="pl-0" col="6">
            {{ results.maxDiscriminationIndex.toFixed(2) }}
          </CCol>
        </CRow>
        <CRow>
          <CCol col="6">
            <strong>Min Discrimination Index: </strong>
          </CCol>
          <CCol class="pl-0" col="6">
            {{ results.minDiscriminationIndex.toFixed(2) }}
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <hr>
    <CRow>
      <CCol>
        <interpretation-table
            :fields="interpretation.pField"
            :items="interpretation.pValue"/>
      </CCol>
      <CCol>
        <interpretation-table
            :fields="interpretation.dField"
            :items="interpretation.dValue"/>
      </CCol>
      <CCol>
        <interpretation-table
            :fields="interpretation.rField"
            :items="interpretation.rValue"/>
      </CCol>
    </CRow>
    <hr>
    <CRow>
      <CCol>
        <p class="mb-0">A = Percentage of all examinees who answered the choice.</p>
        <p class="mb-0">U = Percentage of all examinees in high score group who answered the choice.</p>
        <p class="mb-0">L = Percentage of all examinees in low score group who answered the choice.</p>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import InterpretationTable from "@/components/table/InterpretationTable";

export default {
  name: "examDetail",
  components: {InterpretationTable},
  props: {
    results: Object
  },
  data() {
    return {
      interpretation: {
        pValue: [
          {
            pText: "0.80 ≤ P ≤ 1.00",
            pMeaning: "Too difficult"
          },
          {
            pText: "0.60 ≤ P ≤ 0.80",
            pMeaning: "Hard"
          },
          {
            pText: "0.40 ≤ P ≤ 0.60",
            pMeaning: "Medium"
          },
          {
            pText: "0.20 ≤ P ≤ 0.60",
            pMeaning: "Easy"
          },
          {
            pText: "0.00 ≤ P ≤ 0.20",
            pMeaning: "Too easy"
          }
        ],
        pField: [
          {key: 'pText', label: "P-Value"},
          {key: 'pMeaning', label: "Interpretation"}
        ],
        dValue: [
          {
            dText: "0.40 ≤ R ≤ 1.00",
            dMeaning: "Satisfactory discrimination"
          },
          {
            dText: "0.30 ≤ R ≤ 0.40",
            dMeaning: "Good discrimination"
          },
          {
            dText: "0.20 ≤ R ≤ 0.30",
            dMeaning: "Some revisions may be required to the item"
          },
          {
            dText: "0.10 ≤ R ≤ 0.20",
            dMeaning: "The item needs revision"
          },
          {
            dText: "-1.00 ≤ R ≤ 0.10",
            dMeaning: "The item needs to be removed or completely revised"
          }
        ],
        dField: [
          {key: "dText", label: "R-Value", _style: "width: 40%"},
          {key: 'dMeaning', label: "Interpretation"}
        ],
        rValue: [
          {
            rText: "0.90 ≤ KR ≤ 1.00",
            rMeaning: "Very strong correlation"
          },
          {
            rText: "0.70 ≤ KR ≤ 0.90",
            rMeaning: "Strong correlation"
          },
          {
            rText: "0.40 ≤ KR ≤ 0.70",
            rMeaning: "Moderate correlation"
          },
          {
            rText: "0.10 ≤ KR ≤ 0.40",
            rMeaning: "Weak correlation"
          },
          {
            rText: "0.00 ≤ KR ≤ 0.10",
            rMeaning: "Negligible correlation"
          }
        ],
        rField: [
          {key: 'rText', label: "KR-20 Value"},
          {key: 'rMeaning', label: "Interpretation"}
        ],
      }
    }
  },
  methods: {
    getDate(data) {
      const date = new Date(data)
      return date.getUTCDate() + "/" + (date.getUTCMonth() + 1) + "/" + date.getUTCFullYear()
    }
  }
}
</script>
